/**
 * @function ParticipantCard
 * @description Component for displaying a participant's details.
 * @returns {JSX.Element | null} - The ParticipantCard component.
 */
import { Outlet, useParams } from 'react-router-dom'
import { useGetParticipantByIdQuery } from '../../services/participants'
import { ParticipantCardHeader } from './ParticipantCardHeader'

/**
 * @function ParticipantCard
 * @description Component for displaying a participant's details.
 * @returns {JSX.Element | null} - The ParticipantCard component.
 */
export function ParticipantCard() {
    const { participantId } = useParams()
    const { data: participant, isLoading } = useGetParticipantByIdQuery(participantId)

    if (isLoading) {
        return null
    }

    return (
        <div className="flex flex-col h-full divide-y divide-gray-200">
            <ParticipantCardHeader participant={participant} />
            <Outlet
                context={{
                    participant,
                }}
            />
        </div>
    )
}
